module.exports = __webpack_public_path__ + "img/click-active.8f86d86c.png";